import { gql } from '@apollo/client';

export default gql`
mutation convertPreorder($preorder: ConvertPreorderInput!) {
	convertPreorder(preorder: $preorder) {
    success
    _id
    orderNum
    message
  }
}
`;
